export default "__VITE_ASSET__oVNeHMgo__"